module.exports = __webpack_public_path__ + "static/media/id-card-alt.9edd90c5.svg";